import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

/** Edit action — rounded frame with diagonal pencil (matches provided asset). */
export const MeetingsEditIcon: React.FC<IconProps> = (props) => (
  <Icon
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 4.75H14.25C15.7688 4.75 17 5.98122 17 7.5V8.25M4.75 10V17C4.75 18.5188 5.98122 19.75 7.5 19.75H16.5C18.0188 19.75 19.25 18.5188 19.25 17V10"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <path
      d="M14.5 5.5L8.75 11.25L8 15L11.75 14.25L17.5 8.5L14.5 5.5Z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
  </Icon>
);
